import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledContainer = styled.div`
	position: relative;
	padding-top: 40px;
`;

const StyledFiltersContainer = styled.div`
	display: flex;
	flex-direction: column;
	row-gap: 20px;
	width: 400px;
`;

const StyledSavedContainer = styled.div`
	width: 465px;
	height: 600px;
	margin-left: -35px;
	padding-left: 35px;
	padding-right: 30px;
	overflow-x: hidden;
	overflow-y: auto;

	&::-webkit-scrollbar {
		width: 10px;
	}

	&::-webkit-scrollbar-thumb {
		background-color: rgba(255, 255, 255, 0.1);

		&:hover {
			background-color: rgba(255, 255, 255, 1);
		}
	}
`;

const StyledEmptyContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;
	width: 400px;
	height: 600px;

	${Text} {
		font-weight: 400;
		font-size: 18px;
		text-align: center;
		color: #ffffff;
		opacity: 0.5;
	}
`;

const StyledHeading = styled.div`
	display: flex;
	align-items: center;
	column-gap: 20px;
	padding: 20px 0;
	opacity: 0.75;
	user-select: none;
	pointer-events: none;

	${Text} {
		color: #ffffff;
		font-size: 16px;
		font-weight: 400;
	}
`;

const StyledPanelControlsContainer = styled.div`
	margin-top: 40px;
`;

export {
	StyledContainer,
	StyledFiltersContainer,
	StyledSavedContainer,
	StyledHeading,
	StyledPanelControlsContainer,
	StyledEmptyContainer,
};
